export const JSONParse = <T>(jsonString: string): T | null => {
  try {
    return JSON.parse(jsonString)
  } catch (error) {
    return null
  }
}
